import { RejectCandidateType } from "./rejectCandidateType";

export class RejectCandidateFormData {
    reason: number;
    details: string;
    dnr?: boolean;
    hiredEndDate?: Date;
    isBookingCreditRequested?: boolean;

    private constructor(candidateData: RejectCandidateType) {
        this.reason = undefined;
        this.details = "";
        this.dnr = candidateData.dnr;
        this.hiredEndDate = candidateData.hiredEndDate;
        this.isBookingCreditRequested = candidateData.isBookingCreditRequested;
    }

    static create = (
        candidateData: RejectCandidateType
    ): RejectCandidateFormData => new RejectCandidateFormData(candidateData);
}
